// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3XNDD","modalFooterButton":"ModalNotes_modalFooterButton__3B4LH"};